module.exports = __webpack_public_path__ + "media/images/upload_image-7520cbf1.png";